import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=828b1bca&scoped=true&"
import script from "./Menu.vue?vue&type=script&lang=js&"
export * from "./Menu.vue?vue&type=script&lang=js&"
import style0 from "./Menu.vue?vue&type=style&index=0&id=828b1bca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828b1bca",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MenuList: require('/home/bitrix/frontend/components/sidebars/MenuAside/MenuList.vue').default,BottomLinks: require('/home/bitrix/frontend/components/sidebars/MenuAside/BottomLinks.vue').default})
